module.exports = __webpack_public_path__ + "img/circlelife.7014aeb7.png";